import { RootState } from '../../../store/types'
import { WalletsReducerState } from '../types'

function walletsStateSelector<K extends keyof WalletsReducerState>(
  state: RootState,
  key: K,
) {
  return state.wallets[key]
}

// Simple selectors

export const walletDetailsSelector = (state: RootState) =>
  walletsStateSelector(state, 'currentWalletDetails')

export const walletTopUpModalVisibleSelector = (state: RootState) =>
  walletsStateSelector(state, 'isWalletTopUpModalVisible')

export const walletCheckoutWarningModalVisibleSelector = (state: RootState) =>
  walletsStateSelector(state, 'isWalletCheckoutWarningModalVisible')

export const walletDetailsWalletIdSelector = (state: RootState) =>
  walletDetailsSelector(state)?.id

export const walletDetailsTenantIdSelector = (state: RootState) =>
  walletDetailsSelector(state)?.tenantId

export const walletDetailsCurrencySelector = (state: RootState) =>
  walletDetailsSelector(state)?.balance?.currencyCode
